// src/components/FormatNameStep.js
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatName } from '../utils/formatName';

const FormatNameStep = (props) => {
  const { steps, triggerNextStep } = props;
  const [hasFormatted, setHasFormatted] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (hasFormatted) return;

    const rawInput = steps.name?.value?.trim() || '';
    const offensiveWords = t('offensiveNames', { returnObjects: true });
    const fallback = t('pacobot.fallbackName');
    const locale = i18n.language || 'en';

    const formatted = formatName(rawInput, {
      locale,
      offensiveWords,
      fallbackName: fallback
    });

    steps.name.value = formatted;
    setHasFormatted(true);
    triggerNextStep({ value: formatted });
  }, [hasFormatted, steps, triggerNextStep, t, i18n.language]);

  return null;
};

export default FormatNameStep;